{
    "product_information__id__product_id": "Art.-Nr. {{value}}",
    "product_information__open_in_webshop": "Open in webshop",
    "product_information__id__purchase_order_number": "Sup.-Nr. {{value}}",
    "product_information__id__ean": "EAN {{value}}",
    "product_information__id__gtin": "GTIN {{value}}",
    "description": "Description",
    "recommendations": "Related items",
    "recommendations__tooltip": "Complementary items that are often chosen together.",
    "variants": "Variants",
    "info_block_title__product_group": "Product Group",
    "info_block_title__supplier": "Supplier",
    "info_block_title__total_availability": "Total Availability",
    "info_block_title__packaging": "Packaging",
    "tab_title__info": "Product info",
    "tab_title__availability": "Availability",
    "tab_title__quotes": "Quotes",
    "tab_title__orders": "Orders",
    "tab_title__explorer": "Sales Reports",
    "quick_add": "Add",
    "table_header__total_tooltip": "May differ from unit price × quantity due to line item discounts.",
    "table_header__item_id": "Item no.",
    "table_header__item_name": "Item",
    "search_placeholder": "Search by article"
}
